import { AppHealthPage } from './AppHealthPage'

export const Filterly = () => {
  return <AppHealthPage appName="filterly" displayName="Filterly" />
}

export default Filterly
